// eslint-disable-next-line max-classes-per-file
import { UrlParams } from '@Pages/RetroSynthesis/constants';
import { setUrlParamByName } from '@Pages/RetroSynthesis/utils';

export class PageName {
  static RETRO_SYNTHESIS = `retrosynthesis`;

  static MY_PROJECTS = `myprojects`;

  static DRAW = `draw`;

  static PROJECT_ID = `:projectId`;

  static ROUTE_ID = `:routeId`;

  static TREE_VIEW = 'tree';
}

export class RsRoute {
  static ROOT = `/retrosynthesis`;

  static PROJECTS_LIST = `/${PageName.RETRO_SYNTHESIS}/${PageName.MY_PROJECTS}`;

  static DRAW_STRUCTURE = `/${PageName.RETRO_SYNTHESIS}/${PageName.DRAW}`;

  static PROJECT = `/${PageName.RETRO_SYNTHESIS}/${PageName.MY_PROJECTS}/${PageName.PROJECT_ID}`;

  static PROJECT_ROUTE = `/${PageName.RETRO_SYNTHESIS}/${PageName.MY_PROJECTS}/${PageName.PROJECT_ID}/${PageName.ROUTE_ID}`;

  static PROJECT_ROUTE_TREE_VIEW = `/${PageName.RETRO_SYNTHESIS}/${PageName.MY_PROJECTS}/${PageName.PROJECT_ID}/${PageName.ROUTE_ID}/${PageName.TREE_VIEW}`;

  static get PROJECT_ROUTE_DEFAULT_VIEW() {
    return this.PROJECT_ROUTE_TREE_VIEW;
  }

  static getProjectLink = (projectId) => `/${PageName.RETRO_SYNTHESIS}/${PageName.MY_PROJECTS}/${projectId}`;

  static getProjectLinkLimitTo = (projectId, limitTo) =>
    `/${PageName.RETRO_SYNTHESIS}/${PageName.MY_PROJECTS}/${projectId}?${setUrlParamByName(UrlParams.LIMIT_TO, limitTo)}`;

  static getProjectRouteLink = (projectId, routeId, routeView) => {
    let link = `/${PageName.RETRO_SYNTHESIS}/${PageName.MY_PROJECTS}/${projectId}/${routeId}`;

    if (routeView) {
      link += `/${routeView}`;
    }

    return link;
  };

  static getProjectRouteTreeViewLink = (projectId, routeId) =>
    `/${PageName.RETRO_SYNTHESIS}/${PageName.MY_PROJECTS}/${projectId}/${routeId}/tree`;

  static getProjectRouteTableViewLink = (projectId, routeId) =>
    `/${PageName.RETRO_SYNTHESIS}/${PageName.MY_PROJECTS}/${projectId}/${routeId}/table`;

  static isRsLocation(location) {
    return location && location.pathname && location.pathname.indexOf(this.ROOT) === 0;
  }
}
